/* eslint-disable react/prop-types */
import React, { useState } from "react";
import axios from "axios";
import { Col, Row, Form, Button } from "react-bootstrap";

const AddAttendanceNote = (props) => {
  // Block or Regular Type
  const type = props.type;
  const registerid = props.registerid;
  // Hold the States
  const [NewAttendanceNote, setNewAttendanceNote] = useState("");
  const [recordid, setRecordid] = useState("");
  // Handle Participants to display
  const allParticipants = props.Participants;

  // Handle differing statuses
  let participantsToRender;
  if (type === "regular") {
    participantsToRender = allParticipants.filter((p) => {
      return (p.StripeStatus !== "Cancelled") & (p.StripeStatus !== "Transferred Out");
    });
  } else {
    participantsToRender = allParticipants;
  }

  //Submit the note
  const attendanceNoteSubmit = async (e) => {
    e.preventDefault();
    props.setSubmitClicked(true);
    const requestAttendanceNote = await axios.put(
      `/api/admin/registers/note/${type}`,
      {
        recordid,
        NewAttendanceNote,
        registerid
      },
      {
        withCredentials: true,
      }
    );
    if (requestAttendanceNote.status === 200) {
      setNewAttendanceNote("");
      props.fetchNewData();
      props.setSuccessMessage("Attendance added.");
      window.scrollTo(10, 0);
      return props.setSubmitClicked(false);
    } else {
      props.setSubmitClicked(false);
      window.scrollTo(10, 0);
      return props.setErrorMessage("There was a problem with that request.");
    }
  };

  return (
    <Row className='mt-3 mb-3 shadow-element text-center pt-3 pb-3'>
      <Col>
        <h3>Add An Attendance Note</h3>
        <p>
          Attendance notes can be used to indicate that the participant is not expected or will have
          particular needs, like to leave at a set time.
        </p>
        <Form className='mt-3' onSubmit={attendanceNoteSubmit}>
          <Form.Label>Participant for note</Form.Label>
          <Form.Control
            as='select'
            value={recordid}
            onChange={(e) => setRecordid(e.target.value)}
            custom
          >
            <option value='' disabled defaultValue>
              Select Participant
            </option>
            {participantsToRender.map((Participant) => (
              <option key={Participant._id} value={Participant._id}>
                {Participant.Participant_Name}
              </option>
            ))}
          </Form.Control>
          <Form.Group controlId='ClassTypeForm' className='mt-3'>
            <Form.Label>The Note</Form.Label>
            <Form.Control
              as='textarea'
              type='text'
              maxLength='256'
              value={NewAttendanceNote}
              onChange={(e) => setNewAttendanceNote(e.target.value)}
              required
            />
            <Form.Text className='text-muted'>Short note for the register.</Form.Text>
          </Form.Group>
          <Button variant='success' type='submit' className="mt-2 mb-2">
            Save
          </Button>
        </Form>
      </Col>
    </Row>
  );
};

export default AddAttendanceNote;
